<a (click)="onClick();" class="hover-underline" [attr.href]="link">{{ text }}</a>
